import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMG, BTN } from "@/lib/design";
import { fade } from "../_shared/motion";

const PARTNERS = [
    "DFPS",
    "SSCCs",
    "Juvenile probation departments",
    "Psychiatric hospitals",
    "Crisis units",
    "Case managers",
    "Residential providers",
];

export default function PartnersSection() {
    return (
        <section className="relative py-20 md:py-24">
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <motion.div {...fade} className="lg:col-span-6">
                    <div className="relative rounded-3xl overflow-hidden aspect-[5/4]">
                        <img
                            src={IMG.group}
                            alt="Diverse young men laughing together — community at Crossroads to Change Residential Treatment Center"
                            className="absolute inset-0 w-full h-full object-cover"
                            data-testid="home-group-image"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#0E2A47]/30 to-transparent" />
                    </div>
                </motion.div>
                <motion.div {...fade} className="lg:col-span-6">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        Referral partners
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight">
                        Trusted by Those Who Serve Youth.
                    </h2>
                    <p className="mt-5 text-[16px] text-[#6F6B63] leading-relaxed">
                        Crossroads to Change partners with DFPS, SSCCs,
                        juvenile probation departments, psychiatric
                        hospitals, crisis units, case managers, and
                        residential providers to support male youth needing
                        stabilization, structure, and therapeutic care in a
                        safe and relationship-based environment.
                    </p>
                    <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2.5 text-[14.5px]">
                        {PARTNERS.map((s) => (
                            <li key={s} className="flex items-center gap-2.5 text-[#1A2230]">
                                <span className="h-1.5 w-1.5 rounded-full bg-[#C8A24A]" />
                                {s}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link to="/referrals" className={BTN.primary} data-testid="partners-refer-cta">
                            Submit a referral <ArrowRight className="h-4 w-4" />
                        </Link>
                        <Link to="/who-we-serve" className={BTN.outline} data-testid="partners-who-cta">
                            Who we serve
                        </Link>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
